import { z } from 'zod';

import { SafeIdEncoder } from '@fragment/encoded-id/SafeIdEncoder';
import type { SafeString } from '@fragment/types';

export const PaymentsBusinessCDDIdEncoder = new SafeIdEncoder()
  .withComponent('workspaceId', 'workspaceId')
  .withComponent('instance', 'instance');

export const PaymentsBusinessCDDIdBucketSchema = z
  .string()
  .superRefine((val, ctx) => {
    try {
      PaymentsBusinessCDDIdEncoder.decode(val);
    } catch (err) {
      ctx.addIssue({
        code: 'custom',
        message: `PaymentsBusinessCDDIdBucketSchema was provided with a malformed string: ${val}`,
      });
    }
  })
  .brand<'PaymentsBusinessCDDIdBucket'>();

export type PaymentsBusinessCDDIdBucket = z.infer<
  typeof PaymentsBusinessCDDIdBucketSchema
>;

export const makePaymentsBusinessCDDIdBucket = (
  workspaceId: SafeString,
  instance: number
): PaymentsBusinessCDDIdBucket =>
  PaymentsBusinessCDDIdEncoder.encode({
    workspaceId,
    instance,
  }) as PaymentsBusinessCDDIdBucket;

type DecomposedPaymentsBusinessCDDIdBucket = {
  workspaceId: SafeString;
  instance: number;
};

export const decomposePaymentsBusinessCDDIdBucket = (
  bucket: PaymentsBusinessCDDIdBucket
): DecomposedPaymentsBusinessCDDIdBucket => {
  const { workspaceId, instance } = PaymentsBusinessCDDIdEncoder.decode(bucket);
  return { workspaceId: workspaceId as SafeString, instance: Number(instance) };
};
